// Camera-shutter transition into the 3D studio page.
// Any page with an <a id="explore3dLink"> in its footer gets this behaviour —
// the iris opens from the exact point clicked, then navigates to studio.html
// once the shutter is fully open so the handoff reads as one continuous motion.
export function initIris() {
  const link = document.getElementById('explore3dLink')
  if (!link) return

  const layer = document.createElement('div')
  layer.className = 'iris-layer'
  layer.innerHTML = '<div class="iris-content"><p class="iris-eyebrow">Fiaghmore — Design &amp; 3D</p></div>'
  document.body.appendChild(layer)

  link.addEventListener('click', (e) => {
    e.preventDefault()
    const r = link.getBoundingClientRect()
    const x = ((r.left + r.width / 2) / window.innerWidth) * 100
    const y = ((r.top + r.height / 2) / window.innerHeight) * 100
    layer.style.setProperty('--ix', x + '%')
    layer.style.setProperty('--iy', y + '%')
    requestAnimationFrame(() => layer.classList.add('open'))
    setTimeout(() => {
      window.location.href = link.getAttribute('href') || 'studio.html'
    }, 850)
  })
}
